<template>
  <div class="file-list-show-wrapper">
    <a :href="item.url ? item.url : 'javascript:void(0);'" :key="index" :target="item.url ? '_blank' : '_self'" class="file-list-item c-gray" v-for="(item, index) in list">
      <div>
        <span class="iconfont iconicon-annex"></span>
        <span class="file-list-item-title">{{ item.file_name }}</span>
      </div>
      <div v-if="manage">
        <span @click.stop.prevent="remove(item)" class="iconfont iconclose cursor-pointer"></span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  emits: ['on-remove'],
  name: 'FileListShow',
  props: ['list', 'manage'],
  data() {
    return {}
  },
  methods: {
    remove(value) {
      this.$emit('on-remove', value)
    }
  }
}
</script>

<style lang="less">
.file-list-show-wrapper {
  .file-list-item-title {
    white-space: nowrap;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .file-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 32px;
  }

  .cursor-pointer {
    cursor: pointer;
  }
}
</style>
